import type { RJSFSchema, UiSchema } from '@rjsf/utils'

import type { ConfigDefinition } from '../hooks/useConfigurationSchema'

export function toRjsfSchema(definition: ConfigDefinition): RJSFSchema {
  const { key, xConfigType, xCategory, ...jsonSchema } = definition
  return jsonSchema
}

export function getInitialFormData(
  value: unknown,
  schema: ConfigDefinition
): Record<string, unknown> | undefined {
  const defaults =
    schema.default &&
    typeof schema.default === 'object' &&
    !Array.isArray(schema.default)
      ? (schema.default as Record<string, unknown>)
      : {}

  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return { ...defaults, ...(value as Record<string, unknown>) }
  }

  if (Object.keys(defaults).length > 0) {
    return defaults
  }

  return undefined
}

export function buildConfigurationUiSchema(): UiSchema {
  return {
    'ui:submitButtonOptions': { norender: true },
    'ui:title': '',
    'ui:description': '',
  }
}
